<template>
  <input
    :type="type"
    class="inputBox mb2"
    :style="{marginBottom:mb}"
    :value="value"
    @input="$emit('input', $event.target.value)"
  >
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    type:{
      type:String,
      default:'text'
    },
    value: {
      type: String,
      default: ""
    },
    mb: {
      type: String,
      default: "0"
    }
  }
};
</script>

<style lang="scss" scoped>

input[type=number] {
    -moz-appearance:textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.inputBox {
  width: 100%;
  height: 110px;
  font-size: 30px;
  padding-left: 40px;
  color: #7d7d7d;
  background: #f6f6f6;
  box-sizing: border-box;
  border-radius: 8px;
  display: block;
  line-height: 110px;
}
</style>
